// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Orders_upper__xYMEj {
  display: grid;
  grid-template-columns: 72rem 1.5fr;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Orders_upper__xYMEj {
    grid-template-columns: 60rem 1fr;
  }
}
@media only screen and (max-width: 56.25em) {
  .Orders_upper__xYMEj {
    grid-template-columns: 100%;
  }
}
.Orders_upper_container__Tibgx {
  box-sizing: border-box;
  padding: 2rem;
  width: 100%;
  background-color: var(--color-white);
  border-radius: 2rem;
}
.Orders_upper__metrics__OklQN {
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .Orders_upper__metrics__OklQN {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 56.25em) {
  .Orders_upper__metrics__OklQN {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Orders_upper__metrics__OklQN {
    grid-template-columns: repeat(2, 1fr);
  }
}

.Orders_searchInMiddle__0PySO {
  display: flex;
  width: 100%;
  justify-content: center;
}

.Orders_invoice__list__AAru4 {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Orders_invoice__beside__g3LqA {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  flex-wrap: wrap;
}
.Orders_invoice__checks__nsSJd {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  width: 100%;
}
.Orders_invoice__checks_group__owrrZ {
  align-self: center;
  width: 100%;
}

.Orders_more__hMilv {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background-color: red;
}

.Orders_view__e8e66 {
  position: relative;
}
.Orders_view_menu__3II6g {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 3rem;
  position: absolute;
  left: 20.5rem;
  top: 6rem;
}
.Orders_view_customerMenu__z8uHM {
  right: -20rem;
  top: 6rem;
}
.Orders_view_content__RdGRU {
  width: 35rem;
  margin-top: 3rem;
}

.Orders_sum__AXvtY {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 8px 0;
}

.Orders_line__c5ItX {
  border: 0.1px solid var(--color-grey);
  margin: 2rem 0;
}

.Orders_refunded__slZtz {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-error);
  color: var(--color-white);
  width: 9rem;
}

.Orders_processing__aIUx8 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  width: 9rem;
}

.Orders_void__FVFKt {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-dark);
  color: var(--color-white);
  width: 9rem;
}

.Orders_shipped__4u21X {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-primary);
  color: var(--color-white);
  width: 9rem;
}

.Orders_delivered__uFn1h {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 1rem;
  font-size: 1rem;
  border-radius: 0.5rem;
  background-color: var(--color-green);
  color: var(--color-white);
  width: 9rem;
}

.Orders_st__Nbqwp {
  display: flex;
  justify-content: center;
}

.Orders_channelContainer__WiuHQ {
  position: relative;
}

.Orders_channel__vNlxi {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.Orders_exp__A4aY5 {
  background-color: var(--color-white);
}
.Orders_exp_text__ZjyyS {
  font-size: 1rem;
  font-weight: 700;
}

.Orders_icons__UQDQu {
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.Orders_icons_img__FQcHM {
  display: grid;
  justify-content: right;
  align-items: center;
  width: 100%;
}
.Orders_icons_img__1__CBwRA {
  display: grid;
  justify-content: right;
  align-items: center;
  width: 100%;
  transform: rotateX(180deg);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Orders/Orders.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kCAAA;EACA,SAAA;AADF;AAGE;EALF;IAMI,gCAAA;EAAF;AACF;AAEE;EATF;IAUI,2BAAA;EACF;AACF;AACE;EACE,sBAAA;EACA,aAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;AACJ;AAEE;EACE,sBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAAJ;AAEI;EARF;IASI,qCAAA;EACJ;AACF;AACI;EAZF;IAaI,qCAAA;EAEJ;AACF;AAAI;EAhBF;IAiBI,qCAAA;EAGJ;AACF;;AAyBA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;AAtBF;;AA0BE;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;AAzBJ;AA2BI;EACE,kBAAA;EACA,WAAA;AAzBN;;AA8BA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,kBAAA;AA3BF;AA6BE;EACE,2BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AA3BJ;AA8BE;EACE,aAAA;EACA,SAAA;AA5BJ;AA+BE;EACE,YAAA;EACA,gBAAA;AA7BJ;;AAiCA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,qCAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;EACA,wBAAA;EACA,WAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,mCAAA;EACA,yBAAA;EACA,WAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,sCAAA;EACA,yBAAA;EACA,WAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,uBAAA;AA9BF;;AAiCA;EACE,kBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AA9BF;;AAiCA;EACE,oCAAA;AA9BF;AAiCE;EACE,eAAA;EACA,gBAAA;AA/BJ;;AAmCA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAhCF;AAkCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAhCJ;AAkCI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;AAhCN","sourcesContent":["@import \"../variables/breakpoints\";\n\n.upper {\n  display: grid;\n  grid-template-columns: 72rem 1.5fr;\n  gap: 2rem;\n\n  @media only screen and (max-width: $bp-1000) {\n    grid-template-columns: 60rem 1fr;\n  }\n\n  @media only screen and (max-width: $bp-900) {\n    grid-template-columns: 100%;\n  }\n\n  &_container {\n    box-sizing: border-box;\n    padding: 2rem;\n    width: 100%;\n    background-color: var(--color-white);\n    border-radius: 2rem;\n  }\n\n  &__metrics {\n    box-sizing: border-box;\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n    margin-bottom: 1rem;\n\n    @media only screen and (max-width: $bp-1000) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    @media only screen and (max-width: $bp-900) {\n      grid-template-columns: repeat(3, 1fr);\n    }\n\n    @media only screen and (max-width: $bp-600) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    // &_processing {\n    // \tbackground-color: var(--color-yellow);\n    // }\n\n    // &_shipped {\n    // \tbackground-color: var(--color-primary);\n    // \tcolor: var(--color-white);\n    // }\n\n    // &_refund {\n    // \tbackground-color: var(--color-error);\n    // \tcolor: var(--color-white);\n    // }\n\n    // &_completed {\n    // \tbackground-color: var(--color-green);\n    // \tcolor: var(--color-white);\n    // }\n\n    // &_void {\n    // \tbackground-color: var(--color-dark);\n    // \tcolor: var(--color-white);\n    // }\n  }\n}\n\n.searchInMiddle {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n\n.invoice {\n  &__list {\n    margin-top: 2rem;\n    display: flex;\n    position: relative;\n  }\n\n  &__beside {\n    display: flex;\n    justify-content: space-between;\n    width: 38rem;\n    flex-wrap: wrap;\n  }\n\n  &__checks {\n    display: flex;\n    justify-content: space-between;\n    margin: 1rem 0 2rem 0;\n    width: 100%;\n\n    &_group {\n      align-self: center;\n      width: 100%;\n    }\n  }\n}\n\n.more {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  background-color: red;\n}\n\n.view {\n  position: relative;\n\n  &_menu {\n    color: var(--color-primary);\n    cursor: pointer;\n    font-size: 3rem;\n    position: absolute;\n    left: 20.5rem;\n    top: 6rem;\n  }\n\n  &_customerMenu {\n    right: -20rem;\n    top: 6rem;\n  }\n\n  &_content {\n    width: 35rem;\n    margin-top: 3rem;\n  }\n}\n\n.sum {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 8px 0;\n}\n\n.line {\n  border: 0.1px solid var(--color-grey);\n  margin: 2rem 0;\n}\n\n.refunded {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 1rem;\n  font-size: 1rem;\n  border-radius: 0.5rem;\n  background-color: var(--color-error);\n  color: var(--color-white);\n  width: 9rem;\n}\n\n.processing {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 1rem;\n  font-size: 1rem;\n  border-radius: 0.5rem;\n  background-color: var(--color-yellow);\n  color: var(--color-dark);\n  width: 9rem;\n}\n\n.void {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 1rem;\n  font-size: 1rem;\n  border-radius: 0.5rem;\n  background-color: var(--color-dark);\n  color: var(--color-white);\n  width: 9rem;\n}\n\n.shipped {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 1rem;\n  font-size: 1rem;\n  border-radius: 0.5rem;\n  background-color: var(--color-primary);\n  color: var(--color-white);\n  width: 9rem;\n}\n\n.delivered {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 1rem;\n  font-size: 1rem;\n  border-radius: 0.5rem;\n  background-color: var(--color-green);\n  color: var(--color-white);\n  width: 9rem;\n}\n\n.st {\n  display: flex;\n  justify-content: center;\n}\n\n.channelContainer {\n  position: relative;\n}\n\n.channel {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.exp {\n  background-color: var(--color-white);\n  // border: 1px solid var(--color-grey);\n\n  &_text {\n    font-size: 1rem;\n    font-weight: 700;\n  }\n}\n\n.icons {\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n\n  &_img {\n    display: grid;\n    justify-content: right;\n    align-items: center;\n    width: 100%;\n\n    &__1 {\n      display: grid;\n      justify-content: right;\n      align-items: center;\n      width: 100%;\n      transform: rotateX(180deg);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper": `Orders_upper__xYMEj`,
	"upper_container": `Orders_upper_container__Tibgx`,
	"upper__metrics": `Orders_upper__metrics__OklQN`,
	"searchInMiddle": `Orders_searchInMiddle__0PySO`,
	"invoice__list": `Orders_invoice__list__AAru4`,
	"invoice__beside": `Orders_invoice__beside__g3LqA`,
	"invoice__checks": `Orders_invoice__checks__nsSJd`,
	"invoice__checks_group": `Orders_invoice__checks_group__owrrZ`,
	"more": `Orders_more__hMilv`,
	"view": `Orders_view__e8e66`,
	"view_menu": `Orders_view_menu__3II6g`,
	"view_customerMenu": `Orders_view_customerMenu__z8uHM`,
	"view_content": `Orders_view_content__RdGRU`,
	"sum": `Orders_sum__AXvtY`,
	"line": `Orders_line__c5ItX`,
	"refunded": `Orders_refunded__slZtz`,
	"processing": `Orders_processing__aIUx8`,
	"void": `Orders_void__FVFKt`,
	"shipped": `Orders_shipped__4u21X`,
	"delivered": `Orders_delivered__uFn1h`,
	"st": `Orders_st__Nbqwp`,
	"channelContainer": `Orders_channelContainer__WiuHQ`,
	"channel": `Orders_channel__vNlxi`,
	"exp": `Orders_exp__A4aY5`,
	"exp_text": `Orders_exp_text__ZjyyS`,
	"icons": `Orders_icons__UQDQu`,
	"icons_img": `Orders_icons_img__FQcHM`,
	"icons_img__1": `Orders_icons_img__1__CBwRA`
};
export default ___CSS_LOADER_EXPORT___;
